import { Language } from '../types'

export interface QuizQuestion {
  id: string
  question: { [key in Language]?: string }
  options: {
    text: { [key in Language]?: string }
    score: number
  }[]
}

export interface QuizCategory {
  id: string
  name: { [key in Language]?: string }
  description: { [key in Language]?: string }
  minScore: number
  maxScore: number
  color: string
}

export const quizCategories: QuizCategory[] = [
  {
    id: 'digital_noob',
    name: {
      en: 'Digital Noob 👶',
      id: 'Digital Noob 👶',
      ms: 'Digital Noob 👶',
      th: 'มือใหม่ดิจิทัล 👶',
      vi: 'Gà mờ công nghệ 👶',
      fil: 'Digital Noob 👶',
      km: 'អ្នកថ្មីឌីជីថល 👶',
      lo: 'ມືໃໝ່ດິຈິຕອນ 👶',
      my: 'ဒစ်ဂျစ်တယ် လူသစ် 👶',
    },
    description: {
      en: "You're just starting your journey. The internet is a scary place, but don't worry, we'll help you level up!",
      id: 'Kamu baru memulai perjalananmu. Internet adalah tempat yang menakutkan, tapi jangan khawatir, kami akan membantumu naik level!',
      ms: 'Anda baru memulakan perjalanan anda. Internet adalah tempat yang menakutkan, tetapi jangan risau, kami akan membantu anda naik taraf!',
      th: 'คุณเพิ่งเริ่มต้นการเดินทาง อินเทอร์เน็ตเป็นสถานที่ที่น่ากลัว แต่ไม่ต้องกังวล เราจะช่วยคุณอัปเลเวล!',
      vi: 'Bạn mới bắt đầu hành trình. Internet là một nơi đáng sợ, nhưng đừng lo, chúng tôi sẽ giúp bạn thăng cấp!',
      fil: 'Nagsisimula ka pa lang sa iyong paglalakbay. Nakakatakot ang internet, pero huwag mag-alala, tutulungan ka naming mag-level up!',
      km: 'អ្នកទើបតែចាប់ផ្តើមដំណើររបស់អ្នក។ អ៊ីនធឺណិតគឺជាកន្លែងដ៏គួរឱ្យភ័យខ្លាច ប៉ុន្តែកុំបារម្ភ យើងនឹងជួយអ្នកបង្កើនកម្រិត!',
      lo: 'ເຈົ້າຫາກໍ່ເລີ່ມຕົ້ນການເດີນທາງ. ອິນເຕີເນັດເປັນບ່ອນທີ່ໜ້າຢ້ານ, ແຕ່ບໍ່ຕ້ອງກັງວົນ, ພວກເຮົາຈະຊ່ວຍເຈົ້າອັບເລເວວ!',
      my: 'သင် ခရီးစတင်နေပါပြီ။ အင်တာနက်သည် ကြောက်စရာကောင်းသော နေရာဖြစ်သော်လည်း စိတ်မပူပါနှင့်၊ သင့်ကို အဆင့်မြှင့်တင်ရန် ကျွန်ုပ်တို့ ကူညီပါမည်!',
    },
    minScore: 0,
    maxScore: 20,
    color: 'bg-red-100 text-red-800 border-red-200',
  },
  {
    id: 'scroll_survivor',
    name: {
      en: 'Scroll Survivor 📱',
      id: 'Scroll Survivor 📱',
      ms: 'Scroll Survivor 📱',
      th: 'ผู้รอดชีวิตจากการเลื่อน 📱',
      vi: 'Người lướt web sống sót 📱',
      fil: 'Scroll Survivor 📱',
      km: 'អ្នករស់រានមានជីវិតពីការរមូរ 📱',
      lo: 'ຜູ້ລອດຊີວິດຈາກການເລື່ອນ 📱',
      my: 'Scroll Survivor 📱',
    },
    description: {
      en: 'You know the basics, but sophisticated scams might still catch you off guard. Keep scrolling safely!',
      id: 'Kamu tahu dasar-dasarnya, tapi penipuan canggih mungkin masih bisa menjebakmu. Tetap scrolling dengan aman!',
      ms: 'Anda tahu asasnya, tetapi penipuan canggih mungkin masih boleh memerangkap anda. Teruskan menatal dengan selamat!',
      th: 'คุณรู้พื้นฐาน แต่กลโกงที่ซับซ้อนอาจยังทำให้คุณเผลอได้ เลื่อนดูอย่างปลอดภัยต่อไป!',
      vi: 'Bạn biết những điều cơ bản, nhưng những trò lừa đảo tinh vi vẫn có thể khiến bạn mất cảnh giác. Hãy tiếp tục lướt web an toàn!',
      fil: 'Alam mo ang mga pangunahing kaalaman, ngunit ang mga sopistikadong scam ay maaari pa ring makahuli sa iyo. Magpatuloy sa pag-scroll nang ligtas!',
      km: 'អ្នកដឹងពីមូលដ្ឋាន ប៉ុន្តែការបោកប្រាស់ដ៏ស្មុគស្មាញនៅតែអាចចាប់អ្នកបាន។ រក្សាការរមូរដោយសុវត្ថិភាព!',
      lo: 'ເຈົ້າຮູ້ພື້ນຖານ, ແຕ່ການຫຼອກລວງທີ່ຊັບຊ້ອນອາດຈະຍັງຈັບເຈົ້າໄດ້. ເລື່ອນເບິ່ງຢ່າງປອດໄພຕໍ່ໄປ!',
      my: 'အခြေခံများကို သင်သိသော်လည်း ဆန်းပြားသော လိမ်လည်မှုများက သင့်ကို ဖမ်းမိနိုင်ပါသေးသည်။ ဘေးကင်းစွာ ဆက်လက်ကြည့်ရှုပါ!',
    },
    minScore: 21,
    maxScore: 40,
    color: 'bg-orange-100 text-orange-800 border-orange-200',
  },
  {
    id: 'cyber_curious',
    name: {
      en: 'Cyber Curious 🧐',
      id: 'Cyber Curious 🧐',
      ms: 'Cyber Curious 🧐',
      th: 'ผู้สงสัยไซเบอร์ 🧐',
      vi: 'Tò mò công nghệ 🧐',
      fil: 'Cyber Curious 🧐',
      km: 'អ្នកចង់ដឹងអំពីអ៊ីនធឺណិត 🧐',
      lo: 'ຜູ້ສົງໄສທາງໄຊເບີ 🧐',
      my: 'Cyber Curious 🧐',
    },
    description: {
      en: "You're asking the right questions and spotting most scams. A little more training and you'll be unhackable!",
      id: 'Kamu menanyakan pertanyaan yang tepat dan mengenali sebagian besar penipuan. Sedikit latihan lagi dan kamu akan tak terretas!',
      ms: 'Anda bertanya soalan yang betul dan mengesan kebanyakan penipuan. Sedikit lagi latihan dan anda tidak akan dapat digodam!',
      th: 'คุณตั้งคำถามที่ถูกต้องและสังเกตเห็นกลโกงส่วนใหญ่ ฝึกฝนอีกนิดแล้วคุณจะไม่มีใครแฮ็กได้!',
      vi: 'Bạn đang đặt những câu hỏi đúng và phát hiện ra hầu hết các trò lừa đảo. Thêm một chút đào tạo nữa và bạn sẽ không thể bị hack!',
      fil: 'Nagtatanong ka ng tamang mga tanong at nakikita ang karamihan sa mga scam. Konting pagsasanay pa at hindi ka na maha-hack!',
      km: 'អ្នកកំពុងសួរសំណួរត្រឹមត្រូវ និងស្វែងរកការបោកប្រាស់ភាគច្រើន។ ការបណ្តុះបណ្តាលបន្តិចទៀត ហើយអ្នកនឹងមិនអាច hack បានទេ!',
      lo: 'ເຈົ້າຖາມຄຳຖາມທີ່ຖືກຕ້ອງ ແລະ ສັງເກດເຫັນການຫຼອກລວງສ່ວນໃຫຍ່. ຝຶກຝົນອີກໜ້ອຍໜຶ່ງ ແລະ ເຈົ້າຈະບໍ່ມີໃຜແຮັກໄດ້!',
      my: 'သင်သည် မှန်ကန်သော မေးခွန်းများကို မေးပြီး လိမ်လည်မှု အများစုကို ရှာဖွေတွေ့ရှိနေသည်။ လေ့ကျင့်မှု အနည်းငယ် ထပ်လုပ်ပါက သင်သည် hack ၍ မရနိုင်သူ ဖြစ်လာပါမည်!',
    },
    minScore: 41,
    maxScore: 60,
    color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  },
  {
    id: 'security_savvy',
    name: {
      en: 'Security Savvy 🛡️',
      id: 'Security Savvy 🛡️',
      ms: 'Bijak Keselamatan 🛡️',
      th: 'ผู้เชี่ยวชาญความปลอดภัย 🛡️',
      vi: 'Am hiểu bảo mật 🛡️',
      fil: 'Security Savvy 🛡️',
      km: 'អ្នកជំនាញសុវត្ថិភាព 🛡️',
      lo: 'ຜູ້ຊ່ຽວຊານຄວາມປອດໄພ 🛡️',
      my: 'လုံခြုံရေး ကျွမ်းကျင်သူ 🛡️',
    },
    description: {
      en: 'Impressive! You can smell a phishing email from a mile away. Your friends probably ask you for tech advice.',
      id: 'Mengesankan! Kamu bisa mencium email phishing dari jauh. Teman-temanmu mungkin meminta saran teknologi darimu.',
      ms: 'Hebat! Anda boleh menghidu e-mel phishing dari jauh. Rakan-rakan anda mungkin meminta nasihat teknologi daripada anda.',
      th: 'น่าประทับใจ! คุณสามารถได้กลิ่นอีเมลฟิชชิ่งจากระยะไกล เพื่อนของคุณอาจขอคำแนะนำด้านเทคโนโลยีจากคุณ',
      vi: 'Ấn tượng! Bạn có thể đánh hơi thấy email lừa đảo từ xa. Bạn bè của bạn có thể hỏi bạn lời khuyên về công nghệ.',
      fil: 'Kahanga-hanga! Naamoy mo ang phishing email mula sa malayo. Malamang na humihingi sa iyo ng payo sa tech ang iyong mga kaibigan.',
      km: 'គួរឱ្យចាប់អារម្មណ៍! អ្នកអាចធុំក្លិនអ៊ីមែលបន្លំពីចម្ងាយ។ មិត្តភក្តិរបស់អ្នកប្រហែលជាសុំដំបូន្មានបច្ចេកវិទ្យាពីអ្នក។',
      lo: 'ໜ້າປະທັບໃຈ! ເຈົ້າສາມາດໄດ້ກິ່ນອີເມວຟິດຊິງຈາກໄລຍະໄກ. ເພື່ອນຂອງເຈົ້າອາດຈະຂໍຄຳແນະນຳດ້ານເຕັກໂນໂລຊີຈາກເຈົ້າ.',
      my: 'အထင်ကြီးစရာပါ! သင်သည် phishing အီးမေးလ်ကို အဝေးကပင် သိရှိနိုင်သည်။ သင့်သူငယ်ချင်းများက သင့်ထံ နည်းပညာ အကြံဉာဏ် တောင်းခံကောင်း တောင်းခံပါလိမ့်မည်။',
    },
    minScore: 61,
    maxScore: 80,
    color: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  {
    id: 'firewall_legend',
    name: {
      en: 'Firewall Legend 🔥',
      id: 'Firewall Legend 🔥',
      ms: 'Lagenda Tembok Api 🔥',
      th: 'ตำนานไฟร์วอลล์ 🔥',
      vi: 'Huyền thoại tường lửa 🔥',
      fil: 'Firewall Legend 🔥',
      km: 'រឿងព្រេងជញ្ជាំងភ្លើង 🔥',
      lo: 'ຕຳນານໄຟວໍ 🔥',
      my: 'Firewall Legend 🔥',
    },
    description: {
      en: "You are the chosen one! Scammers have nightmares about you. You're ready to lead the resistance against digital fraud.",
      id: 'Kamu adalah yang terpilih! Penipu bermimpi buruk tentangmu. Kamu siap memimpin perlawanan terhadap penipuan digital.',
      ms: 'Anda adalah yang terpilih! Penipu bermimpi buruk tentang anda. Anda bersedia memimpin penentangan terhadap penipuan digital.',
      th: 'คุณคือผู้ถูกเลือก! มิจฉาชีพฝันร้ายเกี่ยวกับคุณ คุณพร้อมที่จะนำการต่อต้านการฉ้อโกงทางดิจิทัล',
      vi: 'Bạn là người được chọn! Những kẻ lừa đảo gặp ác mộng về bạn. Bạn đã sẵn sàng lãnh đạo cuộc kháng chiến chống gian lận kỹ thuật số.',
      fil: 'Ikaw ang napili! Ang mga scammer ay binabangungot tungkol sa iyo. Handa ka nang pamunuan ang paglaban sa digital fraud.',
      km: 'អ្នកគឺជាអ្នកដែលត្រូវបានជ្រើសរើស! អ្នកបោកប្រាស់មានសុបិនអាក្រក់អំពីអ្នក។ អ្នកត្រៀមខ្លួនរួចជាស្រេចដើម្បីដឹកនាំការតស៊ូប្រឆាំងនឹងការបោកប្រាស់តាមប្រព័ន្ធដីជីថល។',
      lo: 'ເຈົ້າຄືຜູ້ຖືກເລືອກ! ນັກຕົ້ມຕຸນຝັນຮ້າຍກ່ຽວກັບເຈົ້າ. ເຈົ້າພ້ອມທີ່ຈະນຳພາການຕໍ່ຕ້ານການໂກງທາງດິຈິຕອນ.',
      my: 'သင်သည် ရွေးချယ်ခံရသူဖြစ်သည်။ လိမ်လည်သူများသည် သင့်အကြောင်း အိပ်မက်ဆိုးများ မက်ကြသည်။ သင်သည် ဒစ်ဂျစ်တယ် လိမ်လည်မှုကို တိုက်ဖျက်ရန် အဆင်သင့်ဖြစ်နေပါပြီ။',
    },
    minScore: 81,
    maxScore: 100,
    color: 'bg-purple-100 text-purple-800 border-purple-200',
  },
]

export const quizQuestions: QuizQuestion[] = [
  {
    id: 'q1',
    question: {
      en: 'You receive an email from "NetfIix" saying your payment failed. The link looks like "netflix-verify-account.com". What do you do?',
      id: 'Anda menerima email dari "NetfIix" yang mengatakan pembayaran Anda gagal. Tautannya terlihat seperti "netflix-verify-account.com". Apa yang Anda lakukan?',
      ms: 'Anda menerima e-mel daripada "NetfIix" mengatakan pembayaran anda gagal. Pautan kelihatan seperti "netflix-verify-account.com". Apa yang anda lakukan?',
      th: 'คุณได้รับอีเมลจาก "NetfIix" แจ้งว่าการชำระเงินล้มเหลว ลิงก์ดูเหมือน "netflix-verify-account.com" คุณจะทำอย่างไร?',
      vi: 'Bạn nhận được email từ "NetfIix" nói rằng thanh toán của bạn không thành công. Liên kết trông giống như "netflix-verify-account.com". Bạn làm gì?',
      fil: 'Nakatanggap ka ng email mula sa "NetfIix" na nagsasabing nabigo ang iyong pagbabayad. Ang link ay mukhang "netflix-verify-account.com". Ano ang gagawin mo?',
      km: 'អ្នកទទួលបានអ៊ីមែលពី "NetfIix" ដែលនិយាយថាការទូទាត់របស់អ្នកបានបរាជ័យ។ តំណភ្ជាប់មើលទៅដូចជា "netflix-verify-account.com" ។ តើ​អ្នក​ធ្វើអ្វី?',
      lo: 'ເຈົ້າໄດ້ຮັບອີເມວຈາກ "NetfIix" ແຈ້ງວ່າການຊຳລະເງິນຂອງທ່ານລົ້ມເຫຼວ. ລິງກ໌ເບິ່ງຄື "netflix-verify-account.com". ເຈົ້າຈະເຮັດແນວໃດ?',
      my: '"NetfIix" ထံမှ သင့်ငွေပေးချေမှု မအောင်မြင်ကြောင်း အီးမေးလ်တစ်စောင် လက်ခံရရှိသည်။ လင့်ခ်သည် "netflix-verify-account.com" ပုံစံရှိသည်။ သင် ဘာလုပ်မလဲ?',
    },
    options: [
      {
        text: {
          en: 'Click the link and update payment immediately',
          id: 'Klik tautan dan perbarui pembayaran segera',
        },
        score: 0,
      },
      {
        text: {
          en: "Reply to the email asking if it's real",
          id: 'Balas email menanyakan apakah itu asli',
        },
        score: 1,
      },
      {
        text: {
          en: "Ignore it, it's probably fine",
          id: 'Abaikan saja, mungkin tidak apa-apa',
        },
        score: 1,
      },
      {
        text: {
          en: 'Go to Netflix.com directly (not via link) to check account status',
          id: 'Buka Netflix.com langsung (bukan lewat tautan) untuk cek status akun',
        },
        score: 3,
      },
    ],
  },
  {
    id: 'q2',
    question: {
      en: 'A friend on Instagram asks for your phone number to help them "unlock" their account. They say they sent a code to your phone.',
      id: 'Seorang teman di Instagram meminta nomor telepon Anda untuk membantu mereka "membuka kunci" akun mereka. Mereka bilang mengirim kode ke ponsel Anda.',
    },
    options: [
      {
        text: {
          en: 'Send them the code immediately, they are my friend!',
          id: 'Kirim kode segera, mereka teman saya!',
        },
        score: 0,
      },
      {
        text: {
          en: 'Ask them "How are you?" first',
          id: 'Tanya "Apa kabar?" dulu',
        },
        score: 1,
      },
      {
        text: {
          en: 'Call them on another channel (WhatsApp/Phone) to verify',
          id: 'Telepon mereka di saluran lain (WhatsApp/Telepon) untuk verifikasi',
        },
        score: 3,
      },
      {
        text: { en: 'Give them a fake code', id: 'Berikan kode palsu' },
        score: 2,
      },
    ],
  },
  {
    id: 'q3',
    question: {
      en: 'You see an ad for a PS5 for only $100. The seller wants payment via Gift Cards.',
      id: 'Anda melihat iklan PS5 hanya seharga $100. Penjual meminta pembayaran via Gift Card.',
    },
    options: [
      {
        text: { en: 'Buy it! What a steal!', id: 'Beli! Murah banget!' },
        score: 0,
      },
      {
        text: {
          en: 'Ask for photos of the product first',
          id: 'Minta foto produk dulu',
        },
        score: 1,
      },
      {
        text: {
          en: "Report the ad and scroll away. It's a scam.",
          id: 'Laporkan iklan dan pergi. Itu penipuan.',
        },
        score: 3,
      },
      {
        text: { en: 'Ask to meet in person', id: 'Minta bertemu langsung' },
        score: 2,
      },
    ],
  },
  {
    id: 'q4',
    question: {
      en: 'What makes a password strong?',
      id: 'Apa yang membuat kata sandi kuat?',
    },
    options: [
      {
        text: { en: 'My birthday + my name', id: 'Ulang tahun + nama saya' },
        score: 0,
      },
      {
        text: { en: 'Password123', id: 'Password123' },
        score: 0,
      },
      {
        text: {
          en: 'Long, random mix of characters, unique for each site',
          id: 'Panjang, campuran karakter acak, unik untuk setiap situs',
        },
        score: 3,
      },
      {
        text: {
          en: 'A difficult word like "Supercalifragilistic"',
          id: 'Kata sulit seperti "Supercalifragilistic"',
        },
        score: 1,
      },
    ],
  },
  {
    id: 'q5',
    question: {
      en: 'Someone calls claiming to be from your bank. They need your OTP to "stop a hack".',
      id: 'Seseorang menelepon mengaku dari bank. Mereka butuh OTP Anda untuk "menghentikan peretasan".',
    },
    options: [
      {
        text: {
          en: 'Give the OTP quickly to save your money',
          id: 'Berikan OTP cepat untuk selamatkan uang',
        },
        score: 0,
      },
      {
        text: {
          en: 'Hang up and call the official bank number on your card',
          id: 'Tutup dan telepon nomor resmi di kartu bank Anda',
        },
        score: 3,
      },
      {
        text: {
          en: 'Ask for their employee ID',
          id: 'Minta ID karyawan mereka',
        },
        score: 1,
      },
      {
        text: {
          en: 'Tell them to call back later',
          id: 'Suruh telepon lagi nanti',
        },
        score: 1,
      },
    ],
  },
  {
    id: 'q6',
    question: {
      en: 'You win a lottery you never entered! They just need a small "processing fee" to release the funds.',
      id: 'Anda menang lotere yang tidak pernah diikuti! Mereka hanya butuh "biaya proses" kecil untuk mencairkan dana.',
    },
    options: [
      {
        text: { en: "Pay the fee, I'm rich!", id: 'Bayar biayanya, aku kaya!' },
        score: 0,
      },
      {
        text: {
          en: 'Ask if they can deduct the fee from the winnings',
          id: 'Tanya apakah biaya bisa dipotong dari hadiah',
        },
        score: 1,
      },
      {
        text: {
          en: "It's a classic Advance Fee Fraud. Block and delete.",
          id: 'Ini Penipuan Biaya Dimuka klasik. Blokir dan hapus.',
        },
        score: 3,
      },
      {
        text: { en: 'Google the lottery name', id: 'Google nama loterenya' },
        score: 2,
      },
    ],
  },
  {
    id: 'q7',
    question: {
      en: 'Which of these is safe to share on public social media?',
      id: 'Mana yang aman dibagikan di media sosial publik?',
    },
    options: [
      {
        text: { en: 'My home address', id: 'Alamat rumah saya' },
        score: 0,
      },
      {
        text: {
          en: "My mother's maiden name (common security question)",
          id: 'Nama gadis ibu kandung (pertanyaan keamanan umum)',
        },
        score: 0,
      },
      {
        text: {
          en: 'A photo of my boarding pass',
          id: 'Foto boarding pass saya',
        },
        score: 0,
      },
      {
        text: {
          en: 'A photo of my lunch (without location tag)',
          id: 'Foto makan siang saya (tanpa tag lokasi)',
        },
        score: 3,
      },
    ],
  },
  {
    id: 'q8',
    question: {
      en: 'Your computer screen freezes and a popup says "VIRUS DETECTED! Call Microsoft Support immediately".',
      id: 'Layar komputer macet dan popup bilang "VIRUS TERDETEKSI! Hubungi Microsoft Support segera".',
    },
    options: [
      {
        text: {
          en: 'Call the number on the screen',
          id: 'Telepon nomor di layar',
        },
        score: 0,
      },
      {
        text: {
          en: 'Download the software they suggest',
          id: 'Unduh software yang disarankan',
        },
        score: 0,
      },
      {
        text: {
          en: 'Force restart computer and run your own antivirus scan',
          id: 'Paksa restart komputer dan jalankan scan antivirus sendiri',
        },
        score: 3,
      },
      {
        text: { en: 'Wait for it to go away', id: 'Tunggu sampai hilang' },
        score: 1,
      },
    ],
  },
  {
    id: 'q9',
    question: {
      en: 'What is 2FA (Two-Factor Authentication)?',
      id: 'Apa itu 2FA (Autentikasi Dua Faktor)?',
    },
    options: [
      {
        text: { en: 'Logging in twice', id: 'Login dua kali' },
        score: 0,
      },
      {
        text: { en: 'Having two passwords', id: 'Punya dua password' },
        score: 1,
      },
      {
        text: {
          en: 'An extra security layer (like a code sent to phone) after password',
          id: 'Lapisan keamanan ekstra (seperti kode ke HP) setelah password',
        },
        score: 3,
      },
      {
        text: { en: "I don't know", id: 'Saya tidak tahu' },
        score: 0,
      },
    ],
  },
  {
    id: 'q10',
    question: {
      en: 'A "Crypto Guru" DMs you promising 500% returns in 24 hours.',
      id: 'Seorang "Guru Kripto" DM menjanjikan keuntungan 500% dalam 24 jam.',
    },
    options: [
      {
        text: {
          en: 'Invest my savings immediately',
          id: 'Investasi tabungan segera',
        },
        score: 0,
      },
      {
        text: {
          en: 'Ask for their credentials',
          id: 'Minta kredensial mereka',
        },
        score: 1,
      },
      {
        text: {
          en: "Report as spam/scam. High returns with zero risk don't exist.",
          id: 'Lapor sebagai spam/scam. Untung besar tanpa risiko itu tidak ada.',
        },
        score: 3,
      },
      {
        text: {
          en: 'Ask friends if they know him',
          id: 'Tanya teman kalau kenal dia',
        },
        score: 1,
      },
    ],
  },
]

export const countries = [
  'Indonesia',
  'Malaysia',
  'Singapore',
  'Thailand',
  'Vietnam',
  'Philippines',
  'Cambodia',
  'Laos',
  'Myanmar',
  'Brunei',
  'Timor-Leste',
  'Australia',
  'United States',
  'United Kingdom',
  'China',
  'Japan',
  'South Korea',
  'India',
  'Other',
]
